export default __webpack_public_path__ + "static/WhatsApp_Logo_1-01-cf971548790ab4db8c33e6b23ee2d230.svg";